import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section className="py-20 md:py-32 px-6 bg-white" data-id="element-157">
      <div className="max-w-3xl mx-auto" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-159">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-4" data-id="element-160">
            Lo peor no es la diabetes.
          </h2>
          <h3 className="text-2xl md:text-4xl font-serif text-primary" data-id="element-161">
            Es no saber qué podés comer.
          </h3>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed max-w-2xl mx-auto" data-id="element-162">
          <p data-id="element-163">
            Si convivís con diabetes, prediabetes o resistencia a la insulina,
            seguramente te pasó alguna vez.
          </p>

          <div className="pl-6 border-l-4 border-accent/30 space-y-4 py-2 italic text-gray-600" data-id="element-164">
            <p data-id="element-165">Abrís la heladera.</p>
            <p data-id="element-166">Tenés hambre.</p>
            <p data-id="element-167">Querés comer algo rico.</p>
            <p data-id="element-168">Pero terminás dudando de todo.</p>
          </div>

          <p className="font-medium text-gray-900" data-id="element-169">
            Del pan. De las empanadas. De las medialunas. De los postres.
          </p>

          <p data-id="element-170">Y muchas veces terminás sintiéndote culpable después de comer.</p>

          <p className="bg-green-50 p-6 rounded-2xl text-gray-800 font-medium mt-8" data-id="element-171">
            La realidad es que la mayoría de las personas sienten que la comida
            que les gusta quedó prohibida para siempre.
            <span className="block mt-4 text-primary font-bold text-xl" data-id="element-172">
              Pero no tiene por qué ser así.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}